import apiClient from "./apiClient";

export const getStudentProfile = async (userId) => {
  const response = await apiClient.post("/User/GetStudentDetailsByID", {
    ID: -1,
    UserID: userId,
  });

  return Array.isArray(response.data) ? response.data[0] : response.data;
};
